module.exports = __webpack_public_path__ + "static/stm-case-study-218440caaf4d14335dd1f20a152b833c.webp";